export default "__VITE_ASSET__15561a13__"